import store from '@/store/index.js';
import { LOCAL_STORAGE_ALTERNATIVE_MESSAGE } from '@/utils/constants/checkin.constants';

const defaultNameRoutes = {
  checkin_step: 'checkIn',
  select_brand: 'select-brand',

  // MDM Data ----------------------------
  register_patient: 'patient-registry',

  // No MDM Data ----------------------------
  register_patient_public: 'patient-registry-public',

  // Contact Validator ----------------------------
  patient_validation_contact_types: 'patient-validation-contact-types',
  patient_validation_select_contact: 'patient-validation-select-contact',
  patient_validation_insert_token: 'patient-validation-insert-token',

  // Vaccine Flow ----------------------------
  login_error: 'login-error',

  // Exams ----------------------------
  exams_step: 'exams-list',
  exams_add: 'send-exams',
  upload_medical_order: 'upload-medical-order',
  exams_skip: 'exams-skip',
  search_exams: 'search-exams',
  cart: 'cart',
  add_exams_check: 'add-exams-check',
  add_exams_service_desk: 'add-exams-service-desk',

  // AmountExams -------------------
  amount_exams: 'amount_exams',

  // AdvantagesCheckin --------------
  advantages_checkin: 'advantages_checkin',

  // Professional ----------------------------
  professional_identification: 'professional-identification',
  check_professional_identification: 'check-professional-identification',
  loading_medical_identity: 'loading-medical-identity',

  // Questionnaire ----------------------------
  questions_step: 'questions',
  questions_conclusion_step: 'questions-conclusion',
  questionnaries_step: 'questionnaires',

  // Assinatura digital ----------------------------
  signature: 'digital-signature',

  // Payment ----------------------------
  payment_type_choice: 'payment-choice',
  credit_card_payment: 'credit-card-payment',
  pix_payment: 'pix-payment',
  payment_resume: 'payment-resume',
  payment_method: 'payment-methods',
  payment_methods: 'payment-methods',
  payment_pre_loading: 'payment-pre-loading',
  payment_error_service_desk: 'payment-error-service-desk',
  // private
  private_payment_denied: 'payment-denied',
  private_payment_success: 'payment-success',
  // insurance
  insurance_card_step: 'insurance-card',
  insurance_authorized_step: 'insurance-authorized',
  irregular_insurance: 'irregular-insurance',
  insurance_service_desk: 'service-desk-insurance',
  // Amil
  authorization_token_amil: 'validation-token-amil',
  validation_response: 'validation-response',
  validation_loading: 'validation-loading',
  validation_service_desk: 'validation-service-desk',

  // Bradesco
  unscheduled_exams_step: 'unscheduled-exams',

  // Queue ----------------------------
  end_queue_step: 'checkin-conclusion',
  // queue_notification is disabled for now
  queue_notification: 'queue-notification',

  // simple conclusion route
  checkin_conclusion_simple: 'checkin-conclusion-simple',

  service_unavailable: 'servico-indisponivel',
};

export const FlowOptions = Object.freeze({
  // Routes that differ or are unique based on a variable (queue/default/)
  DEFAULT: {
    admission_done: 'checkin-conclusion',
    end_flow_success: 'checkin-conclusion',
    exams_service_desk: 'service-desk-exams',
    irregular_phone_number: 'irregular-phone-number',
    check_service_desk: 'service-desk-checkin',
    ...defaultNameRoutes,
  },

  QUEUE: {
    end_flow_success: 'unit-arrival',
    admission_done: 'checkin-conclusion',
    queue_end_flow: 'checkin-conclusion',
    exams_service_desk: 'service-desk-exams',
    irregular_phone_number: 'irregular-phone-number',
    check_service_desk: 'service-desk-checkin',
    ...defaultNameRoutes,
  },

  MOBILE: {
    admission_done: 'checkin-conclusion-mobile',
    end_flow_success: 'checkin-conclusion-mobile',
    exams_service_desk: 'service-desk-exams-mobile-service',
    irregular_phone_number: 'irregular-phone-number-mobile-service',
    check_service_desk: 'service-desk-checkin-mobile-service',
    ...defaultNameRoutes,
  },
});

export const routeOptionController = (step) => {
  const currentAdmission = store.state.currentAdmission.data;

  let flowType = 'DEFAULT';
  const isUnitMobile = store.getters.isMobileService;
  const isUnitQueue = store.getters.isTrackingActiveInUnit;
  const isUnitT2 = store.getters['global/isT2FlowAllowed'];
  const isVaccineFlow = store.getters['global/isVaccineFlow'];
  const isInCompany = currentAdmission.source.origin === 'CEV';
  const currentAdmissionId = currentAdmission.id;
  const isAdmissionAuthorized = store.state.global.isAdmissionAuthorized;
  const alternativeMessageData = localStorage.alternativeMessageData
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ALTERNATIVE_MESSAGE))
    : false;

  if (isUnitMobile) {
    flowType = 'MOBILE';
  }

  if (
    (isUnitQueue && !alternativeMessageData) ||
    (alternativeMessageData?.admissionId &&
      alternativeMessageData?.admissionId !== currentAdmissionId) ||
    isUnitT2 ||
    isVaccineFlow ||
    isAdmissionAuthorized ||
    isInCompany
  ) {
    flowType = 'QUEUE';
  }

  return FlowOptions[flowType][step];
};
